import request from '@/utils/request.js'
import { message } from 'ant-design-vue'
import { handleUnauthorized } from '@/utils/startLogin'
import { downloadFile } from '@/utils/download'

export const downloadAideDocument = (filename) => downloadFile(
  '/api/v1/aide/guide/document', filename, { filename },
)

export const downloadAideSdk = (filename, platform, version) => downloadFile(
  '/api/v1/aide/guide/sdk', filename, { filename, platform, version },
)

// id 为量化任务的数字主键，UUID 由后端放入签名链接。
export const getModelDownloadUrl = (id) => request({
  url: `/api/v1/quantization/${id}/download-url`,
  method: 'get',
  silentError: true,
})

export const downloadQuantizedModel = async (id) => {
  try {
    // 每次点击即时获取，不缓存、不记录签名链接。
    const { url } = await getModelDownloadUrl(id)
    return downloadFile(url)
  } catch (error) {
    if (error.response?.status === 401) {
      handleUnauthorized()
    } else {
      message.error(error.response?.status === 404 ? '模型文件不存在/尚未生成' : '获取下载链接失败，请稍后重试')
    }
    return false
  }
}

export const reuseModel = (taskId, sha256, signal) => request({
  url: `/api/v1/quantization/${taskId}/model/reuse`,
  method: 'post',
  data: { sha256 },
  signal,
  // 秒传是可选优化，任何失败均由上传流程静默回退。
  silentError: true,
  skipAuthRedirect: true,
  returnFullResponse: true,
})

export const getAideDocumentUrl = (filename) => {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
  return `${baseUrl}/api/v1/aide/guide/document?filename=${encodeURIComponent(filename)}`
}

// 在线预览 ModelInfer 开发文档，接口直接返回 Markdown 文本。
export const getModelInferGuide = () =>
  request({
    url: '/api/v1/aide/guide/document?filename=ModelInfer_Guide.md',
    method: 'get',
  })

//上传模型
export const streamFile = (id, data, key) => {
  return request({
    url: `/api/v1/quantization/${id}/model`,
    method: 'post',
    responseType: "blob",
    headers: {
      ...key,
      "Content-type": "multipart/form-data",
    },
    data,
  })
}

//硬件平台
export const getPlatform = () => {
  return request({
    url: '/api/v1/quantization/platform',
    method: 'get'
  })
}

//上传数据集
export const uploadDataset = (id, name, data, key) => {
  return request({
    url: `/api/v1/quantization/${id}/${encodeURIComponent(name)}/dataset`,
    method: 'post',
    responseType: "blob",
    headers: {
      ...key,
      "Content-type": "multipart/form-data",
    },
    data,
  })
}

//创建转换
export const createQuantization = (data) => {
  return request({
    url: '/api/v1/quantization',
    method: 'post',
    data,
  })
}

//开始转换
export const startQuantization = (id) => {
  return request({
    url: `/api/v1/quantization/${id}/start`,
    method: 'post',
  })
}

// 更新转换
export const updateQuantization = (data, id) => {
   return request({
    url: `/api/v1/quantization/${id}`,
    method: 'patch',
    data
  })
}

//停止转换
export const stopQuantization = (id) => {
  return request({
    url: `/api/v1/quantization/${id}/stop`,
    method: 'get'
  })
}

//状态轮询
export const getStatus = (id) => {
  return request({
    url: `/api/v1/quantization/${id}/status`,
    method: 'get'
  })
}

//模型详情
export const getModelDetail = (id) => {
  return request({
    url: `/api/v1/quantization/${id}`,
    method: 'get'
  })
}

//模型转化列表
export const getQuantization = (params) => {
   return request({
    url: '/api/v1/quantization',
    method: 'get',
    params
  })
}
